import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ArchivedListRoutingModule } from './archived-list-routing.module';
import { ArchivedListComponentComponent } from './archived-list-component.component';
import { SharedModule } from 'src/app/core/shared-modules/shared.module';
import { TrackerPopupComponent } from './tracker-popup/tracker-popup.component';
import { PopupStatusComponent } from './popup-status/popup-status.component';


@NgModule({
  declarations: [
    ArchivedListComponentComponent,
    TrackerPopupComponent,
    PopupStatusComponent
  ],
  imports: [
    CommonModule,
    ArchivedListRoutingModule,
    SharedModule
  ]
})
export class ArchivedListModule { }
